<script setup>
import * as iotapi from "../iotapi.js";
import IndicadorChart from "./IndicadorChart.vue";
import { ref, onMounted } from "vue";

const indicadores = ref({});
const dataFetched = ref(false);

onMounted(async () => {
  await fetchData();
});

const t = (key) => {
  return iotapi.i18next.t(key);
};

const fetchData = async () => {
  try {
    const url = iotapi.API_BASE + "/indicadores";
    const res = await (await fetch(url)).json();
    for (const indicador in res) {
      const key = iotapi.filtraEntityId(indicador);
      indicadores.value[key] = res[indicador];
    }
    dataFetched.value = true;
  } catch (e) {
    console.error(e);
  }
};
</script>

<template>
  <div>
    <div class="header section powered-design" id="home">
      <div class="shapes-container">
        <div class="shape shape-circle shape-circle-1">
          <div data-aos="fade-up-left" data-aos-duration="1500"></div>
        </div>
        <div class="shape shape-circle shape-circle-2">
          <div data-aos="fade-up-left" data-aos-duration="1200" data-aos-delay="500"></div>
        </div>
        <div class="shape shape-ring animation--rotating-diagonal">
          <div></div>
        </div>
        <div class="shape shape-triangle shape-animated">
          <div class="animation--rotating"></div>
        </div>
        <div class="shape pattern-dots-1"></div>
      </div>
      <div class="container bring-to-front">
        <div class="row">
          <div class="col-md-12 menu-header text-center" id="indicadors">
            <i class="fa fa-pie-chart fa-5x accent mb-3"></i>
            <h1 class="heading-line bold">{{ t("smart.indicadores.indicadores") }}</h1>
          </div>
        </div>
        <div class="container">
          <div class="row-menu" style="margin-top: -85px">
            <ul class="row list_style_none m-0 p-0">
              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.ciudad')" class="scrollto" href="./indicadors.html#ciudad">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-users fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.ciudad") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.economia')" class="scrollto" href="./indicadors.html#economia">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-coins fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.economia") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.entorno')" class="scrollto" href="./indicadors.html#entorno">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-wind fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.entorno") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.salud')" class="scrollto" href="./indicadors.html#salud">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-hospital fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.salud") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.agua')" class="scrollto" href="./indicadors.html#agua">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-water fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.agua") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.residuos')" class="scrollto" href="./indicadors.html#residuos">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-truck fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.residuos") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.tecnologia')" class="scrollto" href="./indicadors.html#tecnologia">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-microchip fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.tecnologia") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>

              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.indicadores.turismo')" class="scrollto" href="./indicadors.html#turismo">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-person fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.indicadores.turismo") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <section class="section alter3-features" id="ciudad">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-users fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.ciudad") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.ISO4_1"
              :unidad="t('smart.indicadores.habitantes')"
            ></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_3" :unidad="'Hab./Km2'"></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.ISO4_18"
              :unidad="t('smart.indicadores.habitantes')"
            ></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_22" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_16" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_23" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_17" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_24" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO4_26" :unidad="'%'"></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="economia">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-coins fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.economia") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO5_1" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO5_5" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO5_6"></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="entorno">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-wind fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.entorno") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO8_2" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO8_4" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO8_5"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO8_6"></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="salud">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-hospital fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.salud") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO12_3"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO12_5"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO12_6"></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="agua">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-water fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.agua") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_1" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_2" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_3" :unidad="'%'"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_4"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_5"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_6"></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.ISO21_7" :unidad="'%'"></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="residuos">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-truck fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.residuos") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV1"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV2"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV3"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV4"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV5"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV6"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV7"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV8"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_RV9"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC1"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC2"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC3"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC4"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC5"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC6"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC7"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC8"
              :unidad="t('smart.indicadores.unidades')"
            ></indicador-chart>
            <!-- Lo dejamos desactivado mientras no haya mas valores
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_RE_EC10"
              :unidad="t('smart.indicadores.toneladas')"
            ></indicador-chart>
            -->
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="tecnologia">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-microchip fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.tecnologia") }}</h2>
          </div>
          <ul class="row list_style_none m-0 p-0">
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TE_SE1"
              :unidad="t('smart.indicadores.visitas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TE_WF1"
              :unidad="t('smart.indicadores.unidades')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TE_FO1"
              :unidad="t('smart.indicadores.metros')"
            ></indicador-chart>
          </ul>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="turismo">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-heading text-center">
            <i class="fas fa-person fa-2x accent mb-3"></i>
            <h2 class="heading-line">{{ t("smart.indicadores.turismo") }}</h2>
          </div>
          <ul class="row list_style_none col-md-12 m-0 p-0">
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_VA1"
              :unidad="t('smart.indicadores.visitas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_TA1"
              :unidad="t('smart.indicadores.personas')"
            ></indicador-chart>
            <indicador-chart v-if="dataFetched" :indicador="indicadores.IP_TU_PO1" :unidad="'%'"></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_GT1"
              :unidad="t('smart.indicadores.euros')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_NU1"
              :unidad="t('smart.indicadores.usuarios')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_NU2"
              :unidad="t('smart.indicadores.usuarios')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_NV1"
              :unidad="t('smart.indicadores.visitas')"
            ></indicador-chart>
            <indicador-chart
              v-if="dataFetched"
              :indicador="indicadores.IP_TU_NV2"
              :unidad="t('smart.indicadores.visitas')"
            ></indicador-chart>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
